import type { Theme } from '@mui/material';

export const getBarColor = (theme: Theme, index: number) =>
  [
    theme.colors.commentNegative,
    theme.colors.commentNeutral,
    theme.colors.commentPositive,
  ][index];

export const styles = {
  secondTreeItemLevel: {
    marginLeft: '-5px',
    '.MuiTreeItem-iconContainer': {
      display: 'none',
    },
  },

  legend: {
    display: 'flex',
    flexGrow: 1,
    marginLeft: '12px',
  },

  legendLabel: (index: number) => (theme: Theme) => ({
    width: '100%',
    borderBottom: '4px solid',
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    borderColor: getBarColor(theme, index),
  }),

  relevanceLegend: {
    width: '100%',
    height: '2rem',
    justifyContent: 'space-between',
    paddingLeft: 2,
  },

  relevanceIcon: {
    position: 'relative',
  },

  relevanceIconFiller: (percent: number) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    svg: {
      clipPath: `inset(${(1 - percent) * 100}% 0 0 0)`,
    },
  }),

  hint: (theme: Theme) => ({
    display: 'flex',
    backgroundColor: theme.colors.primary[50],
    color: theme.colors.primary[500],
    borderRadius: '4px',
    padding: '8px 12px',
    alignItems: 'center',
  }),

  alert: (theme: Theme) => ({
    ...theme.typography.caption2,
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.primary[50],
    justifyContent: 'center',
    px: 1.5,
    py: 0,
  }),

  errorMsg: {
    textAlign: 'center',
    padding: 4,
  },
};
